import { ResourceLanguage } from 'i18next'

import translation from './translation.json'

const es: ResourceLanguage = {
  translation
}

export default es
